import FormattedMessage from 'I18n/components/FormattedMessage';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import { H2 } from 'UIComponents/elements/headings';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ApprovalRequestAccessModalHeader = props => {
  const {
    closeRequestAccessModal
  } = props;
  return /*#__PURE__*/_jsxs(UIDialogHeader, {
    children: [/*#__PURE__*/_jsx(H2, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.ApprovalRequestAccess.modal.heading"
      })
    }), /*#__PURE__*/_jsx(UIDialogCloseButton, {
      "data-test-id": "approval-modal-close",
      onClick: closeRequestAccessModal
    })]
  });
};
export default ApprovalRequestAccessModalHeader;